




















import { defineNuxtComponent } from '~/utils/nuxt3-migration'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { ciSparkles } from '~/icons/source/solid/sparkles'

export default defineNuxtComponent({
  components: {
    CBadge
  },
  props: {
    badgeText: {
      type: String,
      required: true
    },
    bgClass: {
      type: String,
      default: 'tw-bg-white'
    }
  },
  setup() {
    return {
      ciSparkles
    }
  }
})
